import { useEffect, useState } from "react";
import { getGuestCart } from "../utils/guestCart";

export default function useGuestCart() {
  const [items, setItems] = useState(() => getGuestCart());

  useEffect(() => {
    const refresh = () => {
      setItems(getGuestCart());
    };

    window.addEventListener("miniMilesGuestCartUpdated", refresh);
    window.addEventListener("storage", refresh);

    return () => {
      window.removeEventListener("miniMilesGuestCartUpdated", refresh);
      window.removeEventListener("storage", refresh);
    };
  }, []);

  return {
    items,
    totalItems: items.reduce(
      (sum, item) => sum + Number(item.quantity || 0),
      0
    ),
    subtotal: items.reduce(
      (sum, item) => sum + Number(item.price || 0) * Number(item.quantity || 0),
      0
    ),
  };
}
